import { addCollection, addIcon } from '@iconify/react';

import { ICONIFY_ICON_BUNDLE } from './iconify-bundle.generated';

// Register the offline icon bundle so icons resolve from memory instead of being fetched from
// api.iconify.design during Navina's critical initial load. Icons missing from the bundle (e.g. fully
// dynamic names) still fall back to the Iconify API automatically.
function registerBundledIconCollections(): void {
	for (const collection of ICONIFY_ICON_BUNDLE) {
		addCollection(collection);
	}
}

registerBundledIconCollections();

addIcon('navina:logo', {
	body: `<svg viewBox="0 0 60.83 62.12" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
  <path d="M15.09 49.59a.82.82 0 01.25.69.91.91 0 01-.41.66.85.85 0 01-.48.15.9.9 0 01-.63-.27l-6.88-6.9a.87.87 0 01-.26-.62.87.87 0 01.89-.87.85.85 0 01.62.26zm5.78-13.51a1 1 0 10-1 1 1 1 0 001-1zm26.52-29a7 7 0 00-7 7v16.7l-.5-.51C39.7 30.11 24.24 14.4 19 9.35a7.83 7.83 0 00-5.39-2.26 6.72 6.72 0 00-4.33 1.53 6.83 6.83 0 00-2.53 4.91 7.29 7.29 0 002 5.46C13 23.43 19.61 29.92 26 36.19c6 5.92 12.21 12.05 16.2 16.19a7.34 7.34 0 005.28 2.26 6.93 6.93 0 006.92-6.32 6.23 6.23 0 000-.74V14a7 7 0 00-7.01-6.94zM20.55 42.39L8.19 30a.9.9 0 00-.62-.26.88.88 0 00-.89.88.83.83 0 00.26.61L19.3 43.65a.88.88 0 00.62.26 1 1 0 00.69-.31.87.87 0 00.2-.72 1 1 0 00-.26-.49zm-10-3.46a.85.85 0 00-.62-.26.86.86 0 00-.88.87.9.9 0 00.25.62l9.57 9.59a.88.88 0 001.47-.38v-.07a.85.85 0 00-.23-.8zm-2.5 10.23a.72.72 0 00-.5-.23.53.53 0 00-.41.18.54.54 0 00-.09.44A7.41 7.41 0 0012.1 55a3.07 3.07 0 00.48.09h.1a.49.49 0 00.46-.29.65.65 0 00-.18-.7zM16.64 34a.88.88 0 001.52-.62.9.9 0 00-.25-.62l-9.72-9.7a.85.85 0 00-.62-.26.87.87 0 00-.89.87.83.83 0 00.26.61zM17 51.79a1 1 0 101 1 1 1 0 00-1-1zM7.45 38a1 1 0 10-1-1 1 1 0 001 1z"/>
</svg>
`,
	width: 60.83,
	height: 62.12,
});
